/* eslint-disable react/jsx-no-undef */
// /* eslint-disable no-unused-vars */
import React, { Component } from "react";
import { connect } from "react-redux";
import { cloneDeep } from "lodash";

// Components Imports
import AddComponents from "./AddComponents";
import SignatureListPane from "./SignatureListPane";
import CoverpageThemes from "./CoverpageThemes";
import CutomizeCoverpagePane from "./CutomizeCoverpagePane";
import StripePaymentListPane from "./StripePaymentListPane";

import {
  addComponentInDocument,
  updateDraggedSection,
  updateDocumentSectionAction,
  toggleCoverpageView,
  coverpageThemeAction,
  addDocumentComponentAction,
  updateDocumentComponentAction,
  updateDocumentClickedComponentID,
  executeCommand,
  removeComponentInDocument,
  undoComponentUpdate,
  forceUpdateEditorSectionIdAction,
} from "../../actions/DocumentActions";
import { QuotationActions, ToolbarActions } from "../../actions";

import {
  nukeEditorState,
  initEditorState,
} from "../../actions/EditorActions/editorActions";

// Import services
import {
  addDocumentComponentService,
  updateDocumentComponentService,
  uploadImageService,
} from "../../actions/DocumentActions/services";

// import services
import {
  addTemplateComponentService,
  updateTemplateComponentService,
} from "../../actions/DocumentTemplateActions/templateService";

import { PIPELINE, COVERPAGETEMPLATES, DOCUMENTS } from "../../constants";
import { DOCUMENT_COMPONENT_TYPES } from "../../constants/document";

// Utility Imports
// import { GlobalUtils } from "../../utils/index";
// import { getContentForComponent } from "../../utils/documentUtils";

import AddComponentCommand from "../../commands/addComponentCommand";
import UpdateComponentCommand from "../../commands/updateComponentCommand";

// DESTRUCTURING
const { addDealTableTab, updateToolPaneData } = QuotationActions;
const { DOCUMENT_STATUS_HASMAP } = PIPELINE;
const { THEME_THUMBNAILS } = COVERPAGETEMPLATES;
const { DOCUMENT_MODE } = DOCUMENTS;
const { updateAddComponentinToolbarAction } = ToolbarActions;

// Declaration
const DOCUMENT = "DOCUMENT";
const TEMPLATE = "TEMPLATE";
const FORM = "FORM";

class DocumentComponents extends Component {
  state = {
    editPane: null,
  };

  componentDidMount = () => {
    let currentPaneView;
    if (this.props.mode === DOCUMENT_MODE.DOCUMENT) {
      currentPaneView = this._getPaneView();
    } else if (this.props.mode === DOCUMENT_MODE.TEMPLATE) {
      currentPaneView = this._getPaneView();
    }
    this.setState({
      editPane: currentPaneView,
    });
  };

  componentWillReceiveProps = nextProps => {
    const { coverpage, appliedCoverpageTheme } = nextProps;
    if (
      coverpage &&
      coverpage.data &&
      nextProps.coverpageThemeActionData === "OpenThemePane" &&
      !coverpage.lock
    ) {
      this.setState({
        editPane: (
          <CoverpageThemes
            sectionData={coverpage.data.attributes}
            closeCoverpageThemePane={this._closeCoverpageThemePane}
            toggleCoverpageThemePane={this.props.coverpageThemeAction}
            changeCoverpageTheme={this._changeCoverpageTheme}
            appliedTheme={appliedCoverpageTheme}
          />
        ),
      });
    } else if (
      coverpage &&
      coverpage.data &&
      nextProps.coverpageThemeActionData === "OpenCustomizationPane" &&
      !coverpage.lock
    ) {
      this.setState({
        editPane: (
          <CutomizeCoverpagePane
            sectionData={coverpage.data.attributes}
            toggleCustomizeCoverpagePane={this.props.coverpageThemeAction}
            changeCoverpageColorOpacity={this._changeCoverpageColorOpacity}
            changeCoverpageImageOpacity={this._changeCoverpageImageOpacity}
            changeBackgroundColor={this._changeBackgroundColor}
            changeBackgroundImage={this._changeBackgroundImage}
            removeBackgroundImage={this._removeBackgroundImage}
            changeBackgroundImagePosition={this._changeBackgroundImagePosition}
            resetTheme={this._resetTheme}
            uploadImageService={uploadImageService}
            closeCoverpageThemePane={this._closeCoverpageThemePane}
          />
        ),
      });
    } else {
      this.setState({
        editPane: null,
      });
    }
  };

  componentWillUnmount = () => {
    if (
      this.props.addComponentType !== DOCUMENT_COMPONENT_TYPES.HEADER_FOOTER
    ) {
      this.props.updateAddComponentinToolbarAction(null);
    }
    this.props.coverpageThemeAction(null);
  };

  _getPaneView = () => {
    const { coverpage, appliedCoverpageTheme } = this.props;
    let paneView = null;
    if (coverpage && this.props.coverpageThemeActionData === "OpenThemePane") {
      paneView = (
        <CoverpageThemes
          sectionData={coverpage.data.attributes}
          closeCoverpageThemePane={this._closeCoverpageThemePane}
          toggleCoverpageThemePane={this.props.coverpageThemeAction}
          changeCoverpageTheme={this._changeCoverpageTheme}
          appliedTheme={appliedCoverpageTheme}
        />
      );
    } else if (
      coverpage &&
      this.props.coverpageThemeActionData === "OpenCustomizationPane"
    ) {
      paneView = (
        <CutomizeCoverpagePane
          sectionData={coverpage.data.attributes}
          toggleCustomizeCoverpagePane={this.props.coverpageThemeAction}
          changeCoverpageColorOpacity={this._changeCoverpageColorOpacity}
          changeCoverpageImageOpacity={this._changeCoverpageImageOpacity}
          changeBackgroundColor={this._changeBackgroundColor}
          changeBackgroundImage={this._changeBackgroundImage}
          removeBackgroundImage={this._removeBackgroundImage}
          changeBackgroundImagePosition={this._changeBackgroundImagePosition}
          resetTheme={this._resetTheme}
          uploadImageService={uploadImageService}
          closeCoverpageThemePane={this._closeCoverpageThemePane}
        />
      );
    }

    return paneView;
  };

  _deleteColorAttr = coverpageSec => {
    const { color } = coverpageSec.data.attributes;
    if (color) {
      delete coverpageSec.data.attributes.color;
    }
    return coverpageSec;
  };

  _updateBackgroundAttr = coverpageSec => {
    const { color, background } = coverpageSec.data.attributes;
    if (color && background === "0404e2") {
      coverpageSec.data.attributes.background = "#fff";
      delete coverpageSec.data.attributes.color;
    }
    return coverpageSec;
  };

  _changeCoverpageTheme = theme => {
    if (theme.appliedTheme !== this.props.appliedCoverpageTheme) {
      const { coverpage } = this.props;
      const element = coverpage ? document.getElementById(coverpage.id) : null;
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      let updatedSection = cloneDeep(coverpage);
      const oldSection = cloneDeep(coverpage);
      updatedSection = this._deleteColorAttr(updatedSection);
      updatedSection.data.attributes = {
        ...updatedSection.data.attributes,
        ...theme,
      };
      this._updateComponent(updatedSection, undefined, false, oldSection);
    }
  };

  _closeCoverpageThemePane = () => {
    this.props.coverpageThemeAction(null);
    this.props.updateToolPaneData(false, "");
  };

  _resetTheme = () => {
    const { appliedCoverpageTheme } = this.props;
    const { coverpage } = this.props;
    let updatedSection = cloneDeep(coverpage);
    const oldSection = cloneDeep(coverpage);
    updatedSection = this._deleteColorAttr(updatedSection);
    const themeData = THEME_THUMBNAILS.filter(
      theme => appliedCoverpageTheme === theme.label,
    );
    if (!appliedCoverpageTheme && themeData.length === 0) {
      const data = THEME_THUMBNAILS.filter(theme => theme.label === "Default");
      updatedSection.data.attributes = {
        ...updatedSection.data.attributes,
        ...data[0].data,
      };
      this._updateComponent(updatedSection, undefined, false, oldSection);
      this.props.coverpageThemeAction("OpenThemePane");
    } else if (
      JSON.stringify(themeData[0].data) !==
      JSON.stringify(updatedSection.data.attributes)
    ) {
      updatedSection.data.attributes = {
        ...updatedSection.data.attributes,
        ...themeData[0].data,
      };
      this._updateComponent(updatedSection, undefined, false, oldSection);
      this.props.coverpageThemeAction("OpenThemePane");
    }
  };

  _changeCoverpageColorOpacity = alphaValue => {
    const { coverpage } = this.props;
    let updatedSection = cloneDeep(coverpage);
    const oldSection = cloneDeep(coverpage);
    updatedSection = this._updateBackgroundAttr(updatedSection);
    updatedSection.data.attributes = {
      ...updatedSection.data.attributes,
      colorTransparency: alphaValue,
    };
    this._updateComponent(updatedSection, undefined, false, oldSection);
  };

  _changeCoverpageImageOpacity = alphaValue => {
    const { coverpage } = this.props;
    let updatedSection = cloneDeep(coverpage);
    const oldSection = cloneDeep(coverpage);
    updatedSection = this._updateBackgroundAttr(updatedSection);
    updatedSection.data.attributes = {
      ...updatedSection.data.attributes,
      imageTransparency: alphaValue,
    };
    this._updateComponent(updatedSection, undefined, false, oldSection);
  };

  _changeBackgroundColor = newColor => {
    let { coverpage } = this.props;
    coverpage = this._deleteColorAttr(coverpage);
    const updatedSection = cloneDeep(coverpage);
    const oldSection = cloneDeep(coverpage);
    updatedSection.data.attributes = {
      ...updatedSection.data.attributes,
      background: newColor,
    };
    this._updateComponent(updatedSection, undefined, false, oldSection);
  };

  _changeBackgroundImage = (imageURL, altTextData) => {
    let { coverpage } = this.props;
    coverpage = this._updateBackgroundAttr(coverpage);
    const updatedSection = cloneDeep(coverpage);
    const oldSection = cloneDeep(coverpage);
    updatedSection.data.attributes = {
      ...updatedSection.data.attributes,
      backgroundImage: imageURL,
      altText: altTextData,
    };
    this._updateComponent(updatedSection, undefined, false, oldSection);
  };

  _changeBackgroundImagePosition = position => {
    const { coverpage } = this.props;
    let updatedSection = cloneDeep(coverpage);
    const oldSection = cloneDeep(coverpage);
    updatedSection = this._updateBackgroundAttr(updatedSection);
    updatedSection.data.attributes = {
      ...updatedSection.data.attributes,
      imagePosition: position,
    };
    this._updateComponent(updatedSection, undefined, false, oldSection);
  };

  _removeBackgroundImage = () => {
    const { coverpage } = this.props;
    let updatedSection = cloneDeep(coverpage);
    const oldSection = cloneDeep(coverpage);
    updatedSection = this._deleteColorAttr(updatedSection);
    updatedSection.data.attributes = {
      ...updatedSection.data.attributes,
      backgroundImage: "",
    };
    this._updateComponent(updatedSection, undefined, false, oldSection);
  };

  _removeActiveComponents = () => {
    const oldComponents = document.getElementsByClassName("active-component");
    for (let i = 0; i < oldComponents.length; i += 1) {
      oldComponents[i].classList.remove("active-component");
    }
  };

  _getComponentService = type => {
    const { mode } = this.props;
    if (type === "ADD") {
      if (mode === DOCUMENT) return addDocumentComponentService;
      if (mode === TEMPLATE) return addTemplateComponentService;
    } else if (type === "UPDATE") {
      if (mode === DOCUMENT) return updateDocumentComponentService;
      if (mode === TEMPLATE) return updateTemplateComponentService;
    }
    return null;
  };

  _addNewComponent = (
    component,
    rowIndex,
    colIndex,
    newRow,
    headerFooterType,
  ) => {
    if (component) {
      const addCommand = new AddComponentCommand({
        component,
        rowIndex,
        colIndex,
        newRow,
        headerFooterType,
        layout: [...this.props.layout],
        components: { ...this.props.components },
        docNo: this.props.docNo,
        docID: this.props.docID,
        mode: this.props.mode,
        addDocumentComponentAction: this.props.addDocumentComponentAction,
        addDealTableTab: this.props.addDealTableTab,
        removeComponentInDocument: this.props.removeComponentInDocument,
      });
      this.props.executeCommand(addCommand);
    }
  };

  _updateComponent = (
    updatedSection,
    addedNewTextSection,
    isMouseHover,
    oldSection,
  ) => {
    const updateCommand = new UpdateComponentCommand({
      mode: this.props.mode,
      isTemplateTypeForm: this.props.isTemplateTypeForm,
      components: { ...this.props.components },
      oldSection,
      isMouseHover,
      clickedActiveComponentId: this.props.clickedActiveComponentId,
      clickedSection: { ...this.props.clickedSection },
      updatedSection,
      updateDocumentComponentAction: this.props.updateDocumentComponentAction,
      updateSectionService: this._getComponentService("UPDATE"),
      addedNewTextSection,
      change: true,
      nukeEditorState: this.props.nukeEditorState,
      initEditorState: this.props.initEditorState,
      updateDocumentClickedComponentID: this.props
        .updateDocumentClickedComponentID,
      layout: [...this.props.layout],
      undoComponentUpdate: this.props.undoComponentUpdate,
      forceUpdateEditorSectionIdAction: this.props
        .forceUpdateEditorSectionIdAction,
      toggleCoverpageView: this.props.toggleCoverpageView,
    });
    this.props.executeCommand(updateCommand);
  };

  _enableAllSections = () => {
    // First remove disable from all sections
    document
      .querySelectorAll(".disable-component")
      .forEach(el => el.classList.remove("disable-component"));
  };

  _hideEditPane = () => {
    this.setState({
      editPane: null,
    });
    this._enableAllSections();
    this.props.updateAddComponentinToolbarAction(null);
    this.props.updateToolPaneData(false, "");
    this.props.updateDocumentClickedComponentID(null, true, null);
  };

  _onLoadSignatureSection = () => {
    const { mode, sectionList, showForm } = this.props;
    return (
      <SignatureListPane
        mode={mode}
        hideEditPane={this._hideEditPane}
        setDraggedSection={this.props.updateDraggedSection}
        sectionList={sectionList}
        signatureWrapperRef={this.props.signatureWrapperRef}
        showForm={showForm}
      />
    );
  };

  _loadStripeSection = () => {
    const { mode, sectionList, showForm } = this.props;
    return (
      <StripePaymentListPane
        mode={mode}
        hideEditPane={this._hideEditPane}
        setDraggedSection={this.props.updateDraggedSection}
        sectionList={sectionList}
        showForm={showForm}
      />
    );
  };

  render() {
    const {
      mode,
      sectionList,
      showDocumentDiffView,
      isDocumentLocked,
      isTemplateTypeForm,
      addComponentType,
      showForm,
      sectionTriggerFrom,
      clickedActiveComponentType,
    } = this.props;
    const disableEdit = isDocumentLocked || (isTemplateTypeForm && showForm);
    if (
      sectionTriggerFrom &&
      sectionTriggerFrom !== this.state.prevTriggeredSection
    ) {
      this._onTriggeredSection();
    }
    if (
      addComponentType &&
      addComponentType === "Signature" &&
      clickedActiveComponentType === "Signature"
    ) {
      return (
        <div className="signaure-container">
          {this._onLoadSignatureSection()}
        </div>
      );
    }

    if (
      addComponentType &&
      addComponentType === "StripePayment" &&
      ((mode === "TEMPLATE" &&
        (!this.props.stripePaymentDetails ||
          (this.props.stripePaymentDetails &&
            !this.props.stripePaymentDetails.is_active))) ||
        mode !== "TEMPLATE")
    ) {
      return (
        <div className="stripe-payment-container">
          {this._loadStripeSection()}
        </div>
      );
    }

    return (
      <div className="components-wrapper animated fadeinright">
        {this.state.editPane || (
          <div className="context-notes  animated fadeinright">
            <div className="notes-header">
              <span
                data-test="notesheader-right-pane-title"
                className="right-pane-title">
                Document blocks
              </span>
            </div>
            <div className="notes-container">
              <AddComponents
                mode={mode}
                sectionList={sectionList}
                updateSection={this._updateComponent}
                addNewComponent={this._addNewComponent}
                setDraggedSection={this.props.updateDraggedSection}
                showDocumentDiffView={showDocumentDiffView}
                disableEdit={disableEdit}
                showEditPane={this._showEditPane}
                addComponentType={addComponentType}
                coverpageThemeAction={this.props.coverpageThemeAction}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const { mode } = props;
  let sectionList = [];
  let docID;
  let docNo;
  let showDocumentDiffView = false;
  let showForm = false;
  let isTemplateTypeForm = false;
  let isDocumentLocked = false;
  let sectionTriggerFrom = null;
  let coverpageThemeActionData = null;
  let appliedCoverpageTheme = "Default";
  const {
    components,
    layout,
    clickedActiveComponentType,
    stripePaymentDetails,
    clickedActiveComponentId,
  } = state.DocumentStore;
  const { clickedSection } = state.EditorStore;
  if (mode === DOCUMENT) {
    const {
      document_order: order,
      document: {
        id,
        docNo: documentNo,
        showForm: showDocForm,
        template_type: typeOfTemplate,
        scope,
        status,
      } = {},
      showDocumentDiffView: showDocumentDiffViewValue,
      sectionTrigger,
      coverpageThemeActionLabel,
    } = state.DocumentStore;
    coverpageThemeActionData = coverpageThemeActionLabel;
    sectionTriggerFrom = sectionTrigger;
    sectionList = order;
    docID = id;
    docNo = documentNo;
    showDocumentDiffView = showDocumentDiffViewValue;
    showForm = showDocForm;
    isTemplateTypeForm =
      typeOfTemplate && typeOfTemplate.toUpperCase() === FORM;
    isDocumentLocked =
      !(scope && scope.write) || status !== DOCUMENT_STATUS_HASMAP.DRAFT;
  }
  if (mode === TEMPLATE) {
    const {
      templateIdOrder: order,
      template: {
        id,
        template_type: typeOfTemplate,
        is_locked: isLocked,
        status,
      },
      coverpageThemeActionLabel,
    } = state.TemplateStore;
    coverpageThemeActionData = coverpageThemeActionLabel;
    sectionList = order;
    docID = id;
    docNo = id;
    isTemplateTypeForm =
      typeOfTemplate && typeOfTemplate.toUpperCase() === FORM;
    isDocumentLocked = isLocked || status !== DOCUMENT_STATUS_HASMAP.DRAFT;
  }
  const { addComponentType } = state.ToolPaneStore;

  // find coverpage
  const coverpageID = Object.keys(components).find(
    componentId =>
      components[componentId].content.section_type ===
        DOCUMENT_COMPONENT_TYPES.COVERPAGE ||
      components[componentId].content.type ===
        DOCUMENT_COMPONENT_TYPES.COVERPAGE,
  );
  let coverpageComponent = null;
  if (
    components &&
    components[coverpageID] &&
    components[coverpageID].content
  ) {
    coverpageComponent = components[coverpageID].content;
  }

  if (coverpageComponent && coverpageComponent.data) {
    appliedCoverpageTheme = coverpageComponent.data.attributes.appliedTheme;
  }

  return {
    docID,
    docNo,
    sectionList,
    showDocumentDiffView,
    showForm,
    layout,
    components,
    isTemplateTypeForm,
    isDocumentLocked,
    sectionTriggerFrom,
    addComponentType,
    coverpageThemeActionData,
    coverpage: coverpageComponent,
    appliedCoverpageTheme,
    clickedActiveComponentType,
    stripePaymentDetails,
    clickedActiveComponentId,
    clickedSection,
  };
};

const mapDispatchToProps = {
  addComponentInDocument,
  addDealTableTab,
  updateDraggedSection,
  updateAddComponentinToolbarAction,
  updateDocumentSectionAction,
  toggleCoverpageView,
  coverpageThemeAction,
  addDocumentComponentAction,
  updateDocumentComponentAction,
  updateToolPaneData,
  updateDocumentClickedComponentID,
  executeCommand,
  removeComponentInDocument,
  nukeEditorState,
  initEditorState,
  undoComponentUpdate,
  forceUpdateEditorSectionIdAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DocumentComponents);



// WEBPACK FOOTER //
// ./src/components/DocumentComponents/DocumentComponents.js